export type Breakpoint = 'sm' | 'md' | 'lg' | 'xl' | '2xl';

const breakpoints: { [key in Breakpoint]: number } = {
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1140,
  '2xl': 1440,
};

export default breakpoints;
